import Switch from "@mui/material/Switch";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WidgetSelect from "../../dashboard/components/WidgetSelect";
import {
  changeMmLatestTradesParamsAction,
  getMmLatestTradesAction,
} from "../treasury.effects";
import { selectMmLatestTradesParams } from "../treasury.selectors";

interface IProps {
  token: string;
}

const REFRESH_INTERVALS = [
  { value: 30, label: "30 seconds" },
  { value: 60, label: "1 minute" },
];

export default function CexLatestTradesFilters({ token }: IProps) {
  const params = useSelector(selectMmLatestTradesParams(token));
  const [refresh, setRefresh] = useState(false);
  const [refreshInterval, setRefreshInterval] = useState(30);
  const dispatch = useDispatch();

  useEffect(() => {
    if (refresh) {
      const interval = setInterval(() => {
        dispatch(getMmLatestTradesAction(token));
      }, refreshInterval * 1000);

      return () => clearInterval(interval);
    }
  }, [refresh, refreshInterval, token]);

  return (
    <div className="absolute top-[10px] right-4 flex items-center gap-8">
      <div className="text-sm">
        Organic trades only
        <Switch
          checked={params?.nonMmTrade || false}
          color="secondary"
          onChange={(e) =>
            dispatch(
              changeMmLatestTradesParamsAction({
                token,
                params: { ...(params || {}), nonMmTrade: e.target.checked },
              } as any)
            )
          }
        />
      </div>

      <div
        className={classNames("text-sm flex items-center", {
          "text-text-2": !refresh,
        })}
      >
        <span className="mr-1">Refresh every</span>
        <WidgetSelect
          className={classNames({
            "text-text-2": !refresh,
          })}
          items={REFRESH_INTERVALS}
          selectedValue={refreshInterval}
          onValueChange={(value) => setRefreshInterval(value as number)}
        />
        <Switch
          checked={refresh}
          color="secondary"
          onChange={(e) => setRefresh(e.target.checked)}
        />
      </div>
    </div>
  );
}
